import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { fileBaseUrl, theme } from "../../../index";
import Select from "react-select";
import ClipLoader from "react-spinners/ClipLoader";

import {
  addSectionBulk,
  assign_intern,
  deleteTestSeries,
  editInstituteTestSeriesStatus,
  editTestSeries,
  fetch_all_interns,
  update_link_intern,
} from "../../../api/testSeries/testseries";
import Snackbar from "@material-ui/core/Snackbar";
import { Container } from "react-bootstrap";
import { s3Delete, s3upload } from "../../../api/aws";

function RenderSingleTestSeriesListingRow(props) {
  const { row, index, deleteCallback, updateTestSeriesAtIndex, allInterns } =
    props;
  const [status, setStatus] = useState(row.status);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [editSeriesData, setEditSeriesData] = useState(row);
  const [languages, setLanguages] = useState([]);
  const [loadingEditSeries, setLoadingEditSeries] = useState(false);

  const [selectedOption, setSelectedOption] = useState(row?.internId);
  const [linkStatus, setLinkStatus] = useState(row?.isLinkActiveForIntern);
  const [SnackBarMessage, setSnackBarMessage] = useState("");
  const [isSnackBarShow, setIsSnackBarShow] = useState(false);

  const [docFile, setDocFile] = useState();
  const [previewUrl, setPreviewUrl] = useState("");

  const { catId, catName, subCatId, subCatName } = useParams();
  let fileRef = useRef(null);

  useEffect(() => {
    setStatus(row?.status);
    setSelectedOption(row?.internId);
    setLinkStatus(row?.isLinkActiveForIntern);
  }, [row]);

  const closeSnack = () => {
    setIsSnackBarShow(false);
  };

  const parser = new DOMParser();
  useEffect(() => {
    setEditSeriesData(row);
  }, [row]);

  const deleteBtnHandler = (id, index) => {
    if (window.confirm("Are you sure you want to delete this Test Series")) {
      deleteTestSeries(id, index, deleteCallback);
    }
  };
  const changeStatusBtnHandler = (id, status) => {
    editInstituteTestSeriesStatus(id, status, () => {
      setStatus(status);
    });
  };

  const changeLinkStatusHandler = async (status) => {
    const response = await update_link_intern({ status, id: row.id });
    if (response.status) {
      setLinkStatus(!linkStatus);
    }
  };

  const editTestSeriesData = async () => {
    setLoadingEditSeries(true);
    try {
      // Make a copy of edit data to avoid direct mutation
      const updatedSeriesData = { ...editSeriesData };

      if (updatedSeriesData["onlyOriginalPaper"] === false) {
        updatedSeriesData["responseSheetUrl"] = null;
      } else if (docFile) {
        // Upload file to S3 if we have a new document file
        const documentObj = await s3upload(
          docFile,
          (progress) => {
            console.log("Upload progress:", progress);
          },
          `testSeries/${catId}_${catName}/${subCatId}_${subCatName}/${updatedSeriesData?.title.replace(
            /\s/g,
            ""
          )}/`
        );

        if (documentObj?.filePath) {
          updatedSeriesData["responseSheetUrl"] = "https://pdfwebviewer.dubuddy.in/?pdf=https://d2dn8tqui3vt36.cloudfront.net/" + documentObj.filePath;
          setSnackBarMessage("File uploaded successfully!");
          setIsSnackBarShow(true);
        }
      }

      const response = await editTestSeries(updatedSeriesData);

      if (response.status) {
        updateTestSeriesAtIndex(updatedSeriesData, index);
        setSnackBarMessage("Test series updated successfully!");
        setIsSnackBarShow(true);
      } else {
        setSnackBarMessage("Failed to update test series");
        setIsSnackBarShow(true);
      }
    } catch (error) {
      console.error("Error updating test series:", error);
      setSnackBarMessage("An error occurred while updating the test series");
      setIsSnackBarShow(true);
    } finally {
      setIsModalVisible(false);
      setLoadingEditSeries(false);
    }
  };

  const handleInputChange = (e) => {
    const obj = { ...editSeriesData };
    obj[e.target.name] = e.target.value;
    setEditSeriesData(obj);
  };

  const handleCopyLink = () => {
    const currentURL = window.location.href;

    const url = new URL(currentURL);

    // const baseUrl = `${url.protocol}//${url.host}/#`;
    const baseUrl = `https://solvetest.dubuddy.in/#`;

    const linkToCopy = `/${row.id}/${catId}`;

    const tempElement = document.createElement("textarea");
    tempElement.value = baseUrl + linkToCopy;
    document.body.appendChild(tempElement);

    tempElement.select();

    document.execCommand("copy");

    document.body.removeChild(tempElement);

    setSnackBarMessage("Link copied!");
    setIsSnackBarShow(true);
    // alert("Link copied!");
  };

  const handleInternSelectChange = async (event) => {
    setSelectedOption();
    const response = await assign_intern({
      internId: event.target.value,
      id: row?.id,
    });

    if (response.status) {
      setSelectedOption(event.target.value);

      setSnackBarMessage(response.message);
      setIsSnackBarShow(true);


    } else {
      setSnackBarMessage("something went wrong!");
      setIsSnackBarShow(true);
      //   alert("something went wrong!");
    }
  };

  const fileOnChange = (event) => {
    var url = event.target.files[0]
      ? URL.createObjectURL(event.target.files[0])
      : "";
    setPreviewUrl(url);
    setDocFile(event.target.files[0]);
  };
  console.log(row, "row")
  return (
    <tr>
      <td align="center">{index + 1}</td>
      <td align="center">{row.id}</td>
      <td align="center">{row.title}</td>
      <td align="center">{row.mode}</td>
      <td align="center">{row.duration}</td>
      <td align="center">{row.isFree ? "Free" : row.price}</td>
      <td align="center">{row.scheduledReleaseDateTime ? new Date(row.scheduledReleaseDateTime).toLocaleString() : "Not Scheduled"}</td>
      <td align="center">{status}</td>
      <td align="center">{linkStatus ? "ACTIVE" : "INACTIVE"}</td>
      <td align="center">
        {row?.solutionSubmittedByIntern === true ? "SUBMITTED" : "NOT SUBMITTED"}
      </td>
      <td align="center">
        <select
          className="form-control"
          id="mySelect"
          value={selectedOption}
          onChange={handleInternSelectChange}
        >
          <option value="">Select an option</option>

          {/* Default empty option */}
          {allInterns?.map((each) => (
            <option value={each?.id}>{each?.name}</option>
          ))}
        </select>
      </td>
      <td align="center">
        {row?.onlyOriginalPaper &&
          <>
            {row?.responseSheetUrl ? (
              <>
                <a
                  href={row?.responseSheetUrl ?? "/"}
                  target="_blank"
                  className="btn btn-danger mr-1"
                  rel="noreferrer"
                >
                  View
                </a>
                <a
                  href={row?.responseSheetUrl.replace("https://pdfwebviewer.dubuddy.in/?pdf=", "") ?? "/"}
                  target="_blank"
                  className="btn btn-danger mr-1"
                  rel="noreferrer"
                >
                  Download
                </a>
              </>
            ) : (
              <button
                className="btn btn-secondary mr-1"
                onClick={() => {
                  setSnackBarMessage("Response sheet URL not available!");
                  setIsSnackBarShow(true);
                }}
              >
                No Document
              </button>
            )}
          </>
        }
        <button
          aria-label="delete"
          onClick={() => {
            // setEditSeriesData(row)
            setIsModalVisible(true);
          }}
          className="btn btn-primary mr-1"
        >
          Edit
        </button>
        {status == "PUBLISHED" ? (
          <button
            aria-label="delete"
            onClick={() => changeStatusBtnHandler(row.id, "UNPUBLISHED")}
            className="btn btn-warning mr-1"
          >
            Unpublish
          </button>
        ) : (
          <button
            aria-label="delete"
            onClick={() => changeStatusBtnHandler(row.id, "PUBLISHED")}
            className="btn btn-success mr-1"
          >
            Publish
          </button>
        )}
        <Link
          to={"/testseries/" + row.id}
          aria-label="delete"
          className="btn btn-primary mr-1"
        >
          Add Question
        </Link>
        <Link
          to={"/testseriesStat/" + row.id}
          aria-label="delete"
          className="btn btn-primary mr-1"
        >
          Analysis
        </Link>

        {linkStatus ? (
          <button
            aria-label="delete"
            onClick={() => changeLinkStatusHandler(false)}
            className="btn btn-warning mr-1"
          >
            Make Link Inactive
          </button>
        ) : (
          <button
            aria-label="delete"
            onClick={() => changeLinkStatusHandler(true)}
            className="btn btn-success mr-1"
          >
            Make Link Active
          </button>
        )}

        {/* 

        <button
          aria-label="delete"
          onClick={() =>changeLinkStatusHandler()}
          className="btn btn-primary mr-1"
        >
          Link Active
        </button> */}
        <button
          aria-label="delete"
          onClick={handleCopyLink}
          className="btn btn-primary mr-1"
        >
          Copy Link
        </button>
      </td>
      <Modal
        size="lg"
        show={isModalVisible}
        onHide={() => setIsModalVisible(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Edit Test Series
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Form.Group
                as={Col}
                md="6"
                className=" d-flex align-items-center align-items-center  "
              >
                <Form.Label>Free</Form.Label>
                <input
                  type="checkbox"
                  className="form-control"
                  value={editSeriesData["isFree"]}
                  checked={editSeriesData["isFree"]}
                  name={"isFree"}
                  onChange={(e) =>
                    handleInputChange({
                      target: {
                        name: "isFree",
                        value: !editSeriesData["isFree"],
                      },
                    })
                  }
                />
              </Form.Group>

              <Form.Group
                as={Col}
                md="6"
                className=" d-flex align-items-center align-items-center  "
              >
                <Form.Label className="">Only Original Paper</Form.Label>

                <input
                  type="checkbox"
                  className="form-control w-50 "
                  value={editSeriesData["onlyOriginalPaper"]}
                  checked={editSeriesData["onlyOriginalPaper"]}
                  name={"onlyOriginalPaper"}
                  onChange={(e) =>
                    handleInputChange({
                      target: {
                        name: "onlyOriginalPaper",
                        value: !editSeriesData["onlyOriginalPaper"],
                      },
                    })
                  }
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  onChange={handleInputChange}
                  value={editSeriesData.title}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Time Duration(min)</Form.Label>
                <Form.Control
                  type="text"
                  name="duration"
                  onChange={handleInputChange}
                  value={editSeriesData.duration}
                  required
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Max Score</Form.Label>
                <Form.Control
                  type="text"
                  name="maxScore"
                  onChange={handleInputChange}
                  value={editSeriesData.maxScore}
                  required
                />
              </Form.Group>

              <Form.Group as={Col} md="6" className="position-relative">
                <Form.Label>Select Release Date and Time</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="scheduledReleaseDateTime"
                  onChange={handleInputChange}
                  value={editSeriesData["scheduledReleaseDateTime"]}
                  required
                />
                <p className="text-white bg-warning py-2 px-3 mt-3">
                  Please select older date if you dont want to add date and
                  time!
                </p>
              </Form.Group>
            </Row>
            {!editSeriesData["onlyOriginalPaper"] && (
              <Row>
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Mode</Form.Label>
                  <select
                    name="mode"
                    class="custom-select"
                    id="validationCustom04"
                    required
                    onChange={handleInputChange}
                  >
                    <option
                      name="mode"
                      value={"PRACTICE"}
                      selected={row.mode == "PRACTICE" ? true : false}
                    >
                      Practice
                    </option>
                    <option
                      name="mode"
                      value={"EXAM"}
                      selected={row.mode == "EXAM" ? true : false}
                    >
                      Exam
                    </option>
                  </select>
                </Form.Group>
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Section Time Shared</Form.Label>
                  <select
                    name="sectionTimeSharedFlag"
                    class="custom-select"
                    id="validationCustom04"
                    required
                    onChange={handleInputChange}
                  >
                    <option
                      name="sectionTimeSharedFlag"
                      value={true}
                      selected={row.sectionTimeSharedFlag ? true : false}
                    >
                      Yes
                    </option>
                    <option
                      name="sectionTimeSharedFlag"
                      value={false}
                      selected={row.sectionTimeSharedFlag ? false : true}
                    >
                      No
                    </option>
                  </select>
                </Form.Group>
              </Row>
            )}

            <Row>
              {editSeriesData["onlyOriginalPaper"] ? (
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Upload</Form.Label>
                  <Form.Control
                    className="form-control"
                    type="file"
                    ref={(ref) => (fileRef = ref)}
                    onChange={(e) => {
                      fileOnChange(e);
                    }}
                  />
                </Form.Group>
              ) : null}

              {!editSeriesData.isFree ? (
                <Form.Group as={Col} md="6" className="position-relative">
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    type="text"
                    name="price"
                    onChange={handleInputChange}
                    value={editSeriesData.price}
                    required
                  />
                </Form.Group>
              ) : null}
            </Row>

            <div className=" mt-4 ">
              {/* {previewUrl?.length == 0 ? (
                editSeriesData?.responseSheetUrl &&
                editSeriesData["onlyOriginalPaper"] == true &&
                !docFile && (
                  <Row className=" d-flex  align-items-center">
                    <Form.Group as={Col} md="6" className="position-relative">
                      <Form.Label>Uploaded Original Paper</Form.Label>
                    </Form.Group>
                    <Form.Group as={Col} md="6" className="position-relative">
                      <img
                        className=" object-fit-contain w-50  my-4"
                        src={fileBaseUrl + editSeriesData?.responseSheetUrl}
                      />
                    </Form.Group>
                  </Row>
                )
              ) : editSeriesData["onlyOriginalPaper"] == true ? (
                <Row className=" d-flex  align-items-center">
                  <Form.Group as={Col} md="6" className="position-relative">
                    <Form.Label>Uploaded Original Paper</Form.Label>
                  </Form.Group>
                  <Form.Group as={Col} md="6" className="position-relative">
                    <img
                      className=" object-fit-contain w-50  my-4"
                      src={previewUrl}
                    />
                  </Form.Group>
                </Row>
              ) : null} */}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setIsModalVisible(false)}
            style={{
              backgroundColor: theme.greyColor,
              color: theme.primaryColor,
            }}
          >
            Close
          </Button>
          <Button
            type="submit"
            variant="primary"
            style={{
              backgroundColor: theme.darkPurpleColor,
              marginLeft: 10,
              color: theme.primaryColor,
            }}
            onClick={() =>
              window.confirm("Are You Sure You Want To Edit?")
                ? editTestSeriesData()
                : console.log("no")
            }
          >
            {loadingEditSeries ? (
              <ClipLoader
                color={theme.primaryColor}
                loading={loadingEditSeries}
              />
            ) : (
              "Edit"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Snackbar
        open={isSnackBarShow}
        onClose={(e) => closeSnack(e)}
        TransitionComponent="TransitionUp"
        message={SnackBarMessage}
      />
    </tr>
  );
}

export default RenderSingleTestSeriesListingRow;
